import { render, staticRenderFns } from "./ContentFeedPreview.vue?vue&type=template&id=1a8983fa&scoped=true&"
import script from "./ContentFeedPreview.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedPreview.vue?vue&type=style&index=0&id=1a8983fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8983fa",
  null
  
)

export default component.exports